<!-- Points Summary -->
<div class="container">
  <fgb-points-summary-bar [backButtonLink]="'/rewards/auctions'" [backButtonTitle]="'Auctions'"></fgb-points-summary-bar>

  <!-- Back Button -->
  <div class="text-danger pt-3 cursor-pointer d-none d-lg-flex align-items-center" [routerLink]="'/rewards/auctions'">
    <span class="material-icons"> keyboard_arrow_left </span>
    <span class="font-size-14 fw-bold">{{ 'rewards.details.back' | translate }}</span>
  </div>
</div>

<!-- Auction Image Desktop -->
<div class="container content mt-lg-3">
  <div class="card">
    <ng-container *ifScreenSize="screenType.Desktop">
      <a href="https://orioles.auctions.mlb.com/" target="_blank">
        <img src="assets/images/rewards/DesktopAuctionsBanner.jpg" class="w-100" />
      </a>
    </ng-container>
    <ng-container *ifScreenSize="screenType.Mobile">
      <a href="https://orioles.auctions.mlb.com/" target="_blank">
        <img src="assets/images/rewards/MobileAuctionsBanner.jpg" class="w-100" />
      </a>
    </ng-container>
  </div>
</div>

<!-- Auction Details -->
<fgbcl-auction-details [auctionId]="id"></fgbcl-auction-details>
